import { Navbar } from "../components/navbar";

export default function AuthLayout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-indigo-50/10 to-white dark:from-gray-900 dark:via-gray-900 dark:to-gray-900">
      <Navbar />
      <div className="flex flex-col items-center justify-center min-h-[calc(100dvh-100px)] px-4 py-12">
        <div className="w-full max-w-md flex flex-col items-center gap-8">
          {/* Branding */}
          <div className="flex flex-col gap-2 text-center">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-indigo-600 via-indigo-500 to-indigo-600 dark:from-indigo-400 dark:via-indigo-300 dark:to-indigo-400 bg-clip-text text-transparent">
              African Polyglot
            </h1>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Learn languages the African way
            </p>
          </div>

          {/* Form */}
          {children}

          {/* Footer */}
          <div className="text-center text-xs text-gray-500 dark:text-gray-400 [&_a]:underline [&_a]:underline-offset-4 [&_a]:hover:text-indigo-600 dark:[&_a]:hover:text-indigo-400 transition-colors">
            By clicking continue, you agree to our{" "}
            <a href="/terms">Terms of Service</a> and{" "}
            <a href="/privacy">Privacy Policy</a>.
          </div>
        </div>
      </div>
    </div>
  );
}
